<template>
  <div class="mt-3">
    <h3 @click="expendWarehouses" class="cursor-pointer font-semibold text-lg">{{ heading }}({{ warehouses.length }})</h3>
    <div v-if="expended" class="grid mt-3 gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
      <div v-for="warehouse in warehouses" :key="'other-warehosue-'+warehouse.id" class="border">
        <div class="px-3 py-2">
          <button
            class="flex w-full justify-between"
            @click="switchWarehouse(warehouse)"
            :class="{'text-red-500': !warehouse.switchable}"
          >
            <span>{{ warehouse.name }}</span>
            <span>Qty: {{ warehouse.count }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OtherWarehouseItems',
  props: {
    warehouses: {
      type: Array,
      default: () => []
    },
    heading: {
      type: String,
      default: 'Other Warehouses'
    },
  },

  data() {
    return {
      expended: false,
    }
  },

  methods: {
    expendWarehouses() {
      this.expended = !this.expended;
    },

    switchWarehouse(warehouse) {
      if (warehouse?.switchable === true) {
        this.$emit('selected', warehouse.id)
      }
    }
  }
}
</script>
